import { createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import { apiCallBegan } from './api';
import applicationConstants from './applicationConstants';
const {
    ENDPOINT_FOR_CLIENT_SLICE,
    JOB_STATS_REPORT_TYPE_ORG,
    JOB_STATS_REPORT_TYPE_UNIT
} = applicationConstants;

const ROUTE_GET_JOB_STATS_BY_CLIENT = 'getJobStatsByClientAndClientAccount';

const createReportState = () => ({
    embedInfo: null,
    error: null,
    loading: true
});

const slice = createSlice({
    name: 'jobStats',
    initialState: {
        activeTab: JOB_STATS_REPORT_TYPE_ORG,
        reports: {
            [JOB_STATS_REPORT_TYPE_ORG]: createReportState(),
            [JOB_STATS_REPORT_TYPE_UNIT]: createReportState()
        }
    },
    reducers: {
        activeTabSelected: (state, action) => {
            const { reportType } = action.payload;
            state.activeTab = reportType;
        },
        embedInfoByClientRequested: (state, action) => {
            const { reportType } = action.payload.data;
            state.reports[reportType] = createReportState();
        },
        embedInfoByClientReceived: (state, action) => {
            const { reportType } = action.meta.request;
            const { jobStatsEmbedInfo } = action.payload;
            const report = state.reports[reportType];
            report.loading = false;
            if (jobStatsEmbedInfo.error) {
                report.error = jobStatsEmbedInfo.error;
                return;
            }
            report.embedInfo = jobStatsEmbedInfo;
        },
        embedInfoByClientError: (state, action) => {
            const { reportType } = action.payload.data;
            const { error } = action.payload;
            const report = state.reports[reportType];
            report.error = error.list[0];
            report.loading = false;
            report.embedInfo = null;
        }
    }
});

export const {
    activeTabSelected,
    embedInfoByClientRequested,
    embedInfoByClientReceived,
    embedInfoByClientError
} = slice.actions;

export default slice.reducer;

export const setActiveTab = reportType => dispatch => {
    dispatch(activeTabSelected({ reportType }));
};

export const loadEmbedInfoByClient = reportType => (dispatch, getState) => {
    const { activeView } = getState().auth;
    const clientId = activeView.client.id;
    const clientAccountId = activeView.clientAccount.id;
    const query = {
        clientId,
        activeView,
        clientAccountId,
        reportType
    };

    dispatch(
        apiCallBegan({
            url: `${ENDPOINT_FOR_CLIENT_SLICE}/${ROUTE_GET_JOB_STATS_BY_CLIENT}`,
            method: 'post',
            data: query,
            onStart: [embedInfoByClientRequested.type],
            onSuccess: [embedInfoByClientReceived.type],
            onError: [embedInfoByClientError.type]
        })
    );
};

export const getJobStatsActiveTab = createSelector(
    state => state.jobStats,
    jobStats => jobStats.activeTab
);

export const getJobStatsReport = reportType =>
    createSelector(
        state => state.jobStats,
        jobStats => jobStats.reports[reportType]
    );
